<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <div>
            <p class="flex"><span class="name">联系人:</span><span class="cont">{{info.name||''}}</span></p>
            <p class="flex"><span class="name">联系电话:</span><span class="cont">{{info.phone||''}}</span></p>
            <p class="flex"><span class="name">公司:</span><span class="cont">{{info.company||''}}</span></p>
            <p class="flex"><span class="name">留言时间:</span><span class="cont">{{info.create_time||''}}</span></p>
            <p class="flex"><span class="name">咨询内容:</span><span class="cont">{{info.content||''}}</span></p>
        </div>

        <div class="drawer-btn"  >

            <a-button type="primary" @click="onClose" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../utils/utils"
    import API from "../api";
    export default {
        name: "InquiryDetails",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig ,
                info:{

                }
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.service.GET_INFO(a).then(res => {
                        this.info =res.data.data.info
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted(){
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
            },

        },
    }
</script>

<style scoped>
.name{display: inline-block;width:80px;text-align: right; color: #333;font-weight: bold}
    .cont{width: calc(100% - 90px);display: inline-block}
</style>
